import styles from './Skeleton.style';

const Skeleton = () => {
  return (
    <div className="skeleton-loading">
      <div className="skeleton-price-line" />
      <div className="skeleton-price-line short" />
      <style jsx>{styles}</style>
    </div>
  );
};

export default Skeleton;
export { Skeleton };
